"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLastEventTimestampMs = GetLastEventTimestampMs;
exports.GetLastEventTimestampMsC = GetLastEventTimestampMsC;
exports.GetEventsAfter = GetEventsAfter;
exports.GetEventsAfterC = GetEventsAfterC;
exports.GetEventsBefore = GetEventsBefore;
exports.GetEventsBeforeC = GetEventsBeforeC;
exports.GetEventsUsernameIndex = GetEventsUsernameIndex;
exports.GetEventsUsernameIndexC = GetEventsUsernameIndexC;
exports.GetEventsDetailType = GetEventsDetailType;
exports.GetEventsDetailTypeC = GetEventsDetailTypeC;
exports.GetEventsAccountNumberC = GetEventsAccountNumberC;
exports.GetEvents = GetEvents;
exports.GetEventsC = GetEventsC;
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
var common_1 = require("./common");
var response_1 = require("@ca/wrap-sdk/src/response");
var sprintf_js_1 = require("sprintf-js");
var js_utils_1 = require("@ca/wrap-sdk/src/js-utils");
function GetLastEventTimestampMs() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetLastEventTimestampMsC(null)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Returns the last event timestamp in milliseconds.
 */
function GetLastEventTimestampMsC(creds) {
    return __awaiter(this, void 0, void 0, function () {
        var params, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, aws_dynamo_1.QueryRangeFirstLast)(common_1.PARTITION, false);
                    return [4 /*yield*/, (0, aws_dynamo_1.QueryC)(creds, common_1.EVENT_BUS_TABLE, common_1.PARTITION, 1, null, null, null, params)];
                case 1:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(resp)];
                    }
                    if (resp.payload.items.length === 0) {
                        return [2 /*return*/, (0, response_1.SuccessResponse)((0, sprintf_js_1.sprintf)("%013d", 0))];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)(parseInt(resp.payload.items[0].id.split("-")[0], 10))];
            }
        });
    });
}
var UNDEFINED = "undefined";
/**
 * TODO: Add page_token
 */
function GetEventsAfter(after_time_ms, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsAfterC(null, after_time_ms, event_bus_table)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * TODO: Add page_token
 */
function GetEventsAfterC(creds, after_time_ms, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsC(creds, after_time_ms, undefined, undefined, undefined, undefined, undefined, undefined, event_bus_table)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * TODO: Add event_bus_table and page_token
 */
function GetEventsBefore(before_time_ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsBeforeC(null, before_time_ms)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * TODO: Add event_bus_table and page_token
 */
function GetEventsBeforeC(creds, before_time_ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsC(creds, undefined, before_time_ms)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * TODO: Add event_bus_table and page_token
 */
function GetEventsUsernameIndex(username_index, is_prefix) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsUsernameIndexC(null, username_index, is_prefix)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetEventsUsernameIndexC(creds, username_index, is_prefix, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!is_prefix) return [3 /*break*/, 2];
                    return [4 /*yield*/, GetEventsC(creds, undefined, undefined, undefined, username_index)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, GetEventsC(creds, undefined, undefined, username_index, undefined, undefined, undefined, undefined, event_bus_table)];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetEventsDetailType(detail_type, is_prefix, page_token, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsDetailTypeC(null, detail_type, is_prefix, page_token, event_bus_table)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetEventsDetailTypeC(creds, detail_type, is_prefix, page_token, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!is_prefix) return [3 /*break*/, 2];
                    return [4 /*yield*/, GetEventsC(creds, undefined, undefined, undefined, undefined, undefined, detail_type, page_token, event_bus_table)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, GetEventsC(creds, undefined, undefined, undefined, undefined, detail_type, undefined, page_token, event_bus_table)];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetEventsAccountNumberC(creds, account_number, page_token, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        var params, resp, keys, b_resp, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = (0, aws_dynamo_1.QueryIndexSortEquals)("account_number", "event", account_number);
                    return [4 /*yield*/, (0, aws_dynamo_1.QueryC)(creds, event_bus_table || common_1.EVENT_BUS_TABLE, common_1.PARTITION, null, page_token, null, null, params)];
                case 1:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        console.log(resp);
                        return [2 /*return*/, resp];
                    }
                    keys = resp.payload.items.map(function (item) {
                        return {
                            partition: item.partition,
                            id: item.id,
                        };
                    });
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchAllC)(creds, event_bus_table || common_1.EVENT_BUS_TABLE, keys)];
                case 2:
                    b_resp = _a.sent();
                    if (b_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(b_resp)];
                    }
                    result = {
                        items: b_resp.payload,
                        page_token: resp.payload.page_token,
                    };
                    result.items.sort(function (a, b) { return (0, js_utils_1.string_cmp)(a.id, b.id); });
                    return [2 /*return*/, (0, response_1.SuccessResponse)(result)];
            }
        });
    });
}
function GetEvents(after_time_ms, before_time_ms, username_index, username_index_prefix, detail_type, detail_type_prefix, page_token, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetEventsC(null, after_time_ms, before_time_ms, username_index, username_index_prefix, detail_type, detail_type_prefix, page_token, event_bus_table)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Pass in one of these arguments.
 *
 * after_time_ms: {number} Return events after this epoch time
 * username_index: {string} Return events that match the username_index
 * username_index_prefix: {string} Return events that start with the given username_index
 * detail_type: {string} Return events that match this detail_type
 * detail_type_prefix: {string} Return events that begin with this
 */
function GetEventsC(creds, after_time_ms, before_time_ms, username_index, username_index_prefix, detail_type, detail_type_prefix, page_token, event_bus_table) {
    return __awaiter(this, void 0, void 0, function () {
        var params, resp, items, keys, b_resp, r_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {};
                    if (typeof after_time_ms !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryRangeRelativeTo)(common_1.PARTITION, (0, sprintf_js_1.sprintf)("%d", after_time_ms), aws_dynamo_1.OP['GT']);
                    }
                    else if (typeof before_time_ms !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryRangeRelativeTo)(common_1.PARTITION, (0, sprintf_js_1.sprintf)("%d", before_time_ms), aws_dynamo_1.OP['LT']);
                    }
                    else if (typeof username_index !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryIndexSortEquals)("username_index", "event", username_index);
                    }
                    else if (typeof username_index_prefix !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryIndexSortBeginsWith)("username_index", "event", username_index_prefix);
                    }
                    else if (typeof detail_type !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryIndexSortEquals)("detail-type", "event", detail_type);
                    }
                    else if (typeof detail_type_prefix !== UNDEFINED) {
                        params = (0, aws_dynamo_1.QueryIndexSortBeginsWith)("detail-type", "event", detail_type_prefix);
                    }
                    else {
                        return [2 /*return*/, (0, response_1.ErrorResponse)({
                                error: "event missing param",
                                params: [
                                    'after_time_ms', 'username_index', 'username_index_prefix',
                                    'event', 'event_prefix'
                                ],
                            })];
                    }
                    return [4 /*yield*/, (0, aws_dynamo_1.QueryC)(creds, event_bus_table || common_1.EVENT_BUS_TABLE, common_1.PARTITION, null, page_token, null, null, params)];
                case 1:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        console.log(resp);
                        return [2 /*return*/, resp];
                    }
                    items = [];
                    if (!(typeof after_time_ms !== UNDEFINED)) return [3 /*break*/, 2];
                    // Since the ids have a nonce at the end, when we request GT <timestamp>
                    // we will get <timestamp>-nonce. We need to chop these items
                    items = resp.payload.items.filter(function (item) {
                        return item.id.split("-")[0] > after_time_ms;
                    });
                    return [3 /*break*/, 4];
                case 2:
                    keys = resp.payload.items.map(function (item) {
                        return {
                            partition: item.partition,
                            id: item.id,
                        };
                    });
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchAllC)(creds, event_bus_table || common_1.EVENT_BUS_TABLE, keys)];
                case 3:
                    b_resp = _a.sent();
                    if (b_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(b_resp)];
                    }
                    items = b_resp.payload;
                    _a.label = 4;
                case 4:
                    r_1 = {
                        items: items.map(function (item) {
                            return {
                                event: item.event,
                                'detail-type': item['detail-type'],
                                username_index: item.username_index,
                                timestamp_ms: parseInt(item.id.split("-")[0], 10),
                                id: item.id,
                            };
                        }),
                        page_token: resp.payload.page_token,
                    };
                    r_1.items.sort(function (a, b) { return a.timestamp_ms - b.timestamp_ms; });
                    return [2 /*return*/, (0, response_1.SuccessResponse)(r_1)];
            }
        });
    });
}
//# sourceMappingURL=events.js.map